import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';


@Injectable()
export class DietasGuard implements CanActivateChild {

    constructor(){}

    canActivateChild(
        rota: ActivatedRouteSnapshot,
        estado: RouterStateSnapshot
    ) : Observable<boolean> | boolean {
        return true;        
    }

}


// WEBPACK FOOTER //
// ./src/app/guards/dietas.guard.ts